import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import SEOHead from '../components/common/SEOHead';

export default function TermsOfService() {
  const { t } = useTranslation('legal');
  return (
    <div className="pub-page min-h-screen py-12 px-4">
      <SEOHead
        title="Conditions d'utilisation"
        description="Conditions générales d'utilisation de Splinity, application de gestion de budget équitable pour couples et colocations."
        path="/conditions-utilisation"
      />
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-primary-600 hover:text-primary-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('backToHome')}
        </Link>

        <div className="pub-card p-8">
          <h1 className="pub-title text-3xl font-bold mb-8">{t('termsOfService.title')}</h1>

          <div className="pub-notice pub-notice--warn rounded-lg p-4 mb-6">
            <p className="pub-state--warn text-sm">{t('termsOfService.betaNotice')}</p>
          </div>

          <div className="pub-prose max-w-none">
            <p className="lead">{t('termsOfService.intro')}</p>

            <h2>{t('termsOfService.article1.title')}</h2>
            <p>{t('termsOfService.article1.content')}</p>

            <h2>{t('termsOfService.article2.title')}</h2>
            <p>{t('termsOfService.article2.content')}</p>

            <h2>{t('termsOfService.article3.title')}</h2>
            <p>{t('termsOfService.article3.intro')}</p>
            <ul>
              <li>{t('termsOfService.article3.email')}</li>
              <li>{t('termsOfService.article3.password')}</li>
              <li>{t('termsOfService.article3.accept')}</li>
            </ul>
            <p>{t('termsOfService.article3.responsibility')}</p>

            <h2>{t('termsOfService.article4.title')}</h2>
            <p>{t('termsOfService.article4.content')}</p>
            <ul>
              <li>{t('termsOfService.article4.freePlan')}</li>
              <li>{t('termsOfService.article4.premiumPlan')}</li>
              <li>{t('termsOfService.article4.duoPlan')}</li>
            </ul>
            <p>{t('termsOfService.article4.vatNote')}</p>
            <p>{t('termsOfService.article4.priceChange')}</p>

            <h2>{t('termsOfService.article5.title')}</h2>
            <p>{t('termsOfService.article5.content1')}</p>
            <p>{t('termsOfService.article5.content2')}</p>
            <p>{t('termsOfService.article5.content3')}</p>

            <h2>{t('termsOfService.article6.title')}</h2>
            <p>{t('termsOfService.article6.content1')}</p>
            <p>{t('termsOfService.article6.content2')}</p>

            <h2>{t('termsOfService.article7.title')}</h2>
            <p>{t('termsOfService.article7.intro')}</p>
            <ul>
              <li>{t('termsOfService.article7.proper')}</li>
              <li>{t('termsOfService.article7.noHarm')}</li>
              <li>{t('termsOfService.article7.noImpersonation')}</li>
              <li>{t('termsOfService.article7.accurate')}</li>
            </ul>

            <h2>{t('termsOfService.article8.title')}</h2>
            <p>{t('termsOfService.article8.content1')}</p>
            <p>{t('termsOfService.article8.content2')}</p>

            <h2>{t('termsOfService.article9.title')}</h2>
            <p>{t('termsOfService.article9.content')}</p>

            <h2>{t('termsOfService.article10.title')}</h2>
            <p>{t('termsOfService.article10.content')}</p>
            <ul>
              <li>{t('termsOfService.article10.maintenance')}</li>
              <li>{t('termsOfService.article10.indirectDamages')}</li>
              <li>{t('termsOfService.article10.decisions')}</li>
            </ul>

            <h2>{t('termsOfService.article11.title')}</h2>
            <p>
              {t('termsOfService.article11.content')}{' '}
              <Link to="/politique-confidentialite" className="text-primary-600 hover:underline">
                {t('termsOfService.article11.privacyPolicyLink')}
              </Link>.
            </p>

            <h2>{t('termsOfService.article12.title')}</h2>
            <p>{t('termsOfService.article12.content1')}</p>
            <p>{t('termsOfService.article12.content2')}</p>
            <p>{t('termsOfService.article12.content3')}</p>

            <h2>{t('termsOfService.article13.title')}</h2>
            <p>{t('termsOfService.article13.content')}</p>

            <h2>{t('termsOfService.article14.title')}</h2>
            <p>{t('termsOfService.article14.content')}</p>

            <h2>{t('termsOfService.article15.title')}</h2>
            <p>{t('termsOfService.article15.content')}</p>

            <h2>{t('termsOfService.article16.title')}</h2>
            <p>{t('termsOfService.article16.content')}</p>

            <p className="pub-subtle text-sm mt-8">
              {t('lastUpdated')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
